
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-media",
      function () {
        return require("private-next-pages/my-media.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-media"])
      });
    }
  